/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalOverviewViewModel } from './ProposalOverviewViewModel';
import {
    ProposalOverviewViewModelFromJSON,
    ProposalOverviewViewModelFromJSONTyped,
    ProposalOverviewViewModelToJSON,
} from './ProposalOverviewViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfIEnumerableOfProposalOverviewViewModel
 */
export interface ResultOfIEnumerableOfProposalOverviewViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<ProposalOverviewViewModel>}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    data?: Array<ProposalOverviewViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIEnumerableOfProposalOverviewViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfIEnumerableOfProposalOverviewViewModel interface.
 */
export function instanceOfResultOfIEnumerableOfProposalOverviewViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfIEnumerableOfProposalOverviewViewModelFromJSON(json: any): ResultOfIEnumerableOfProposalOverviewViewModel {
    return ResultOfIEnumerableOfProposalOverviewViewModelFromJSONTyped(json, false);
}

export function ResultOfIEnumerableOfProposalOverviewViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIEnumerableOfProposalOverviewViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(ProposalOverviewViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfIEnumerableOfProposalOverviewViewModelToJSON(value?: ResultOfIEnumerableOfProposalOverviewViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ProposalOverviewViewModelToJSON)),
        'Count': value.count,
    };
}

